var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","fluid":"","wrap":""}},[(_vm.tasks.length===0)?_c('span',{staticClass:"px-2"},[_vm._v("No tasks have been assigned.")]):_vm._l((_vm.tasks),function(task,index){return _c('assigned-task',{key:index,attrs:{"task":task}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }